import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import { colors } from "../../Shared/colors";
import { useGetHierarchyCompletedTaskQuery } from "../../features/taskSlice";
import moment from 'moment-timezone';
import { usePaginationFromURL } from "../../hooks/usePaginationFromURL";

const columns = [
//   {
//     field: "client",
//     headerName: "Client",
//     width: 150,
//     renderCell: (params) => {
//       return (
//         <Tooltip title={params.row.client}>
//           <div>{params.row.client}</div>
//         </Tooltip>
//       );
//     },
//   },
//   {
//     field: "cellNo",
//     headerName: "Cell No",
//     width: 150,
//     renderCell: (params) => {
//       return <div>+{params.row.cellNo}</div>;
//     },
//   },
  {
    field: "clientName",
    headerName: "Client Name",
    width: 150,
  },
  {
    field: "clientPhone",
    headerName: "Client Phone",
    width: 150,
  },
  {
    field: "currentTaskType",
    headerName: "Task Type",
    width: 150,
  },
  {
    field: "currentSubTypeTask",
    headerName: "Task Sub Type",
    width: 150,
  },
  {
    field: "completedDate",
    headerName: "Completed Date",
    width: 200,
    renderCell: (params) => {
      let date = moment(params.row.completedDate).tz('Asia/Karachi');
      let formattedDate = date.format('ddd, MMM D, YYYY h:mm A');
      return <div>{formattedDate}</div>;
    },
  },
  {
    field: "reason",
    headerName: "Reason",
    width: 150,
  },
  {
    field: "comment",
    headerName: "Comment",
    width: 150,
    renderCell: (params) => {
      return (
        <Tooltip title={params.row.comment}>
          <div>{params.row.comment}</div>
        </Tooltip>
      );
    },
  },
  {
    field: "attachment",
    headerName: "Attachment",
    width: 150,
    renderCell: (params) => {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {params.row.attachment ? (
            <div>
              <a href={params.row.attachment} target="_blank" style={{textDecoration:'none',color:`${colors.brown}`,fontWeight:'bolder',border:`1px solid ${colors.brown}`,padding:'0.5em',borderRadius:'5px'}}>
                click to view
              </a>
            </div>
          ) : (
            <div>no pic</div>
          )}
        </div>
      );
    },
  },
  {
    field: "nextFollowup",
    headerName: "Next Followup",
    width: 200,
    renderCell: (params) => {
      const nextTask = params.row.nextTask;
      if (!nextTask || !nextTask.deadline) {
        return <div style={{ color: "#94a3b8" }}>N/A</div>;
      }
      let date = moment(nextTask.deadline).tz('Asia/Karachi');
      let formattedDate = date.format('ddd, MMM D, YYYY h:mm A');
      return <div>{formattedDate}</div>;
    },
  },
];

export const KpiTaskTable = ({ data }) => {
  // Use URL-based pagination hook (Note: DataGrid uses 0-indexed pages for client-side pagination)
  // Using unique param names to avoid conflicts when used in modals
  const { currentPage: urlPage, pageSize, setPage: setUrlPage, setPageSize } = usePaginationFromURL({
    defaultPage: 1,
    defaultPageSize: 50,
    pageParam: 'kpiTaskPage',
    pageSizeParam: 'kpiTaskPageSize'
  });
  // Convert to 0-indexed for DataGrid (client-side pagination)
  const currentPage = urlPage - 1;
  const setCurrentPage = (page) => {
    const pageNum = typeof page === 'function' ? page(currentPage) : page;
    setUrlPage(pageNum >= 0 ? pageNum + 1 : 1);
  };

  let rows = [];

    data?.forEach((task, index) => {
      rows.push({
        id: task._id || `task-${index}`,
        clientName: task.clientFullName || "Unknown",
        clientPhone: task.clientPhone || "",
        currentTaskType: task?.currentTaskType || "",
        currentSubTypeTask: task?.currentSubTypeTask || "",
        completedDate: task?.completedDate ? new Date(task.completedDate) : null,
        reason: task?.reason || "",
        comment: task?.comment || "",
        attachment: task?.attachment || "",
        nextTask: task?.nextTask || null,
      });
    })
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      pageSize={pageSize}
      page={currentPage}
      onPageSizeChange={(newPageSize) => {
        setPageSize(newPageSize);
        setCurrentPage(0); // Reset to first page when page size changes
      }}
      onPageChange={(newPage) => setCurrentPage(newPage)}
      rowsPerPageOptions={[5, 10, 20]}
      checkboxSelection
      disableSelectionOnClick
      experimentalFeatures={{ newEditingApi: true }}
      pagination
      sx={{
        border: "none",
      }}
    />
  );
};
